<button
class="btn btn-primary"
(click)="displayDetails()"
>Display Details</button>
<p *ngIf="showPassword; else hidden">Secret Password = tuna</p>
<ng-template #hidden>
    <p>Password Hidden</p>
</ng-template>
<p *ngFor="let item of clickLog"
[ngClass]="{'bigItems': item >= 5}"
>{{item}}</p>

<!--[ngStyle]="{backgroundColor: getColor()}"-->